import Card from "react-bootstrap/Card";
import "./DashBox.css";

interface DashBoxProps {
  titulo: string;
  conteudo: string;
  cor: string;
}

//COMPONENTE BATIZADO POR CARLOS MAX :)
export const DashBox: React.FC<DashBoxProps> = (props) => {
  return (
    <Card style={{ borderBottomColor: `${props.cor}`, borderBottomWidth: 5 }} className="card">
      <Card.Body style={{ padding: 9 }}>
        <Card.Text>{props.titulo}</Card.Text>
        <Card.Text className="card-texto">{props.conteudo}</Card.Text>
      </Card.Body>
    </Card>
  );
};
